import { ThreeDots } from '@design/components/three-dots/ThreeDots';
import { ReactNode, RefObject } from 'react';

import styles from './ChatQuestionResponse.module.scss';

export interface ChatQuestionResponseProps {
  title: ReactNode;
  children: ReactNode;
  chatPrompts?: ReactNode[];
  contentRef?: RefObject<HTMLDivElement | null>;
  isQuestionPending?: boolean;
  loaderNode?: ReactNode;
  rightContent?: ReactNode;
  hasExceededUsageLimit?: boolean;
}

export const ChatQuestionResponse = ({
  title,
  children,
  chatPrompts,
  contentRef,
  isQuestionPending = false,
  loaderNode = <ThreeDots className={styles.loader} />,
  rightContent,
  hasExceededUsageLimit,
}: ChatQuestionResponseProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div
          data-testid="question-answer-body"
          className={
            hasExceededUsageLimit ? styles.body : styles.bodyWithBorder
          }
        >
          <div
            data-testid="question-answer-title"
            className={
              hasExceededUsageLimit ? styles.titleRoundedBottom : styles.title
            }
          >
            {title}
          </div>
          {isQuestionPending ? (
            <div className={styles.loaderWrapper}>{loaderNode}</div>
          ) : (
            <section
              data-testid="question-answer-content"
              ref={contentRef}
              className={
                hasExceededUsageLimit
                  ? styles.content
                  : styles.contentWithPadding
              }
            >
              {children}
            </section>
          )}
        </div>
        {chatPrompts && (
          <div className={styles.chatPromptsContainer}>{chatPrompts}</div>
        )}
      </div>
      {rightContent}
    </div>
  );
};
